import React, { useState, useEffect } from 'react';

import { Col, Row, Form, Radio, Button, Select, message } from 'antd';
import { TitleSections } from '../../../../components/TitleSections';
import { SelectMultiplo } from '../../../../components/SelectMultiplo';

import {
  criarConsulta,
  editarConsulta,
  getListaFornecedores,
  getListaTipoCadastros,
} from '../../../../services/cadastroConsulta';

import { GridRazoesReprovacao } from './RazaoReprovacao/gridRazoesReprovacao';

import * as S from '../styles';

export function FormConsulta({
  setEditConsult,
  editConsult,
  setReloadGrid,
  reloadGrid,
}) {
  const [formDisable, setFormDisable] = useState(false);
  const [checked, setChecked] = useState(1);

  const [checkValidation, setCheckValidation] = useState();
  const [listFornecedor, setListFornecedor] = useState([]);
  const [listTipoCadastro, setListTipoCadastro] = useState([]);

  const [form] = Form.useForm();
  const { Option } = Select;

  const getListaTipoCadastro = async () => {
    try {
      const response = await getListaTipoCadastros();
      if (response?.data) {
        setListTipoCadastro(response.data);
      }
      if (!response?.data) {
        message.error(
          'Não foi possível carregar a lista de tipos de consulta.'
        );
      }
    } catch (error) {
      message.error('Não foi possível carregar a lista de tipos de consulta.');
    }
  };

  const getListaFornecedor = async () => {
    try {
      const response = await getListaFornecedores();
      setListFornecedor(response?.data || []);
    } catch (error) {
      message.error('Não foi possivel buscar a lista de fornecedores.');
    }
  };

  const initialState = async () => {
    await getListaTipoCadastro();
    await getListaFornecedor();
  };

  const cleanForm = () => {
    form.setFieldsValue({
      nomeForm: '',
      fornecedorForm: '',
      linkForm: '',
      orientacoesForm: '',
      tipoForm: '',
      tipoCadastro: '',
      validation: '',
      razoesForm: [],
    });
    setEditConsult(false);
  };

  const handlerCreateConsult = async obj => {
    setFormDisable(true);
    try {
      const response = await criarConsulta(obj);
      if (response?.status === 200) {
        setFormDisable(false);
        cleanForm();
        setReloadGrid(!reloadGrid);
        message.success('Consulta criada com sucesso.');
      }
      if (response?.status !== 200) {
        setFormDisable(false);
        message.error('Não foi possível criar a consulta, tente novamente.');
      }
    } catch (error) {
      setFormDisable(false);
      message.error('Não foi possivel registrar a consulta, tente novamente.');
    }
  };

  const handlerEditConsult = async obj => {
    try {
      const response = await editarConsulta(obj);
      if (response?.status === 200) {
        setFormDisable(false);
        cleanForm();
        setReloadGrid(!reloadGrid);
        message.success(`Consulta ${obj?.nome || ''} atualizada com sucesso.`);
      }
      if (response?.status !== 200) {
        setFormDisable(false);
        message.error(
          'Não foi possível atualizar a consulta, tente novamente.'
        );
      }
    } catch (error) {
      setFormDisable(false);
      message.error('Não foi possivel registrar a consulta, tente novamente.');
    }
  };

  const handleSubmitConsult = formValues => {
    const {
      nomeForm,
      fornecedorForm,
      linkForm,
      tipoCadastroForm,
      orientacoesForm,
      tipoForm,
      razoesForm,
    } = formValues;

    const id = editConsult?.id || 0;
    const nome = nomeForm || editConsult?.nome;
    const idFornecedor = fornecedorForm;
    const link = linkForm || editConsult?.link;

    const tiposCadastroConsulta = tipoCadastroForm?.map(item => ({
      id: 0,
      idConsulta: 0,
      idTipoCadastro: item,
    }));
    const orientacao = orientacoesForm || editConsult?.orientacao;
    const idTipoConsulta = tipoForm || editConsult?.idTipoConsulta;
    const idTipoValidacao = checkValidation || editConsult?.idTipoValidacao;
    const payload = {
      id,
      nome,
      idFornecedor,
      link,
      tiposCadastroConsulta,
      idTipoConsulta,
      orientacao,
      idTipoValidacao,
      razoesReprovacaoConsulta: razoesForm,
    };
    if (id) {
      handlerEditConsult(payload);
    }
    if (!id) {
      handlerCreateConsult(payload);
    }
  };

  const handleButtonCancel = () => {
    setEditConsult(null);
  };

  useEffect(() => {
    form.setFieldsValue({
      nomeForm: editConsult?.nome || '',
      fornecedorForm: editConsult?.fornecedor?.id || [],
      linkForm: editConsult?.link || '',
      orientacoesForm: editConsult?.orientacao || '',
      tipoForm: editConsult?.idTipoConsulta || '',
      validation: editConsult?.idTipoValidacao || 1,
      tipoCadastroForm:
        editConsult?.tiposCadastroConsulta?.map(item => item.tipoCadastro.id) ||
        [],
      razoesForm: editConsult?.razoesReprovacaoConsulta,
    });
  }, [editConsult]); // eslint-disable-line

  useEffect(() => {
    initialState();
  }, []);

  return (
    <Col
      justify="center"
      id="col"
      span={24}
      style={{
        borderRadius: '2px',
        overflow: 'auto',
        background: '#fff',
        padding: '42px 28px 0 28px',
      }}
    >
      <Row style={{ marginBottom: 22 }}>
        <TitleSections title="Dados cadastrais da consulta" />
      </Row>
      <S.NameForConsult>
        <h1>{editConsult.nome || ''}</h1>
      </S.NameForConsult>
      <S.StyledForm
        form={form}
        onFinish={values => handleSubmitConsult(values)}
        layout="vertical"
        style={{ width: '100%', maxWidth: '100%', minWidth: '0' }}
      >
        <Row align="center">
          <Radio.Group
            name="validation"
            onChange={e => setCheckValidation(e.target.value)}
            value={checkValidation}
            defaultValue={editConsult?.idTipoValidacao}
            disabled={formDisable}
          >
            <Radio value={1}>Interna</Radio>
            <Radio value={2}>Externa</Radio>
          </Radio.Group>
        </Row>
        <S.StyledForm.Item
          name="nomeForm"
          label="Nome"
          rules={[{ required: true, message: 'o nome deve ser informado' }]}
        >
          <S.InputStyled
            size="large"
            placeholder="Nome"
            disabled={formDisable}
          />
        </S.StyledForm.Item>

        <S.StyledForm.Item
          name="fornecedorForm"
          label="Fornecedor"
          rules={[
            {
              required: true,
              message: 'o fornecedor deve ser informado',
            },
          ]}
        >
          <S.SelectFornecedor
            showArrow
            placeholder="Selecione"
            disabled={formDisable}
            filterOption={(input, option) =>
              option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >=
              0
            }
          >
            {listFornecedor?.map((item, index) => (
              <Option value={item.id} key={index}>
                {item?.nome}
              </Option>
            ))}
          </S.SelectFornecedor>
        </S.StyledForm.Item>

        <S.StyledForm.Item name="linkForm" label="Link">
          <S.InputStyled
            size="large"
            placeholder="Link"
            disabled={formDisable}
          />
        </S.StyledForm.Item>

        <S.StyledForm.Item name="tipoCadastroForm" label="Tipo">
          <SelectMultiplo
            showArrow
            placeholder="Selecione"
            disabled={formDisable}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {listTipoCadastro?.map((item, index) => (
              <Option value={item.id} key={index}>
                {item?.nome}
              </Option>
            ))}
          </SelectMultiplo>
        </S.StyledForm.Item>

        <S.StyledForm.Item name="orientacoesForm" label="Orientações">
          <S.TextArea
            rows={3}
            size="large"
            placeholder="Orientações"
            disabled={formDisable}
          />
        </S.StyledForm.Item>

        <Row align="center">
          <S.StyledForm.Item name="tipoForm">
            <Radio.Group
              name="autMan"
              onChange={e => setChecked(e.target.value)}
              value={checked}
              disabled={formDisable}
            >
              <Radio value={1}>Automático</Radio>
              <Radio value={2}>Manual</Radio>
            </Radio.Group>
          </S.StyledForm.Item>
        </Row>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <S.StyledForm.Item name="razoesForm" hidden={true} />
          <GridRazoesReprovacao
            razoesReprovacaoConsulta={editConsult?.razoesReprovacaoConsulta}
            form={form}
            idConsulta={editConsult?.id || null}
          />
          <S.StyledForm.Item
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative',
              marginTop: '1%',
            }}
          >
            <S.StyledButtonCancel
              type="primary"
              htmlType="button"
              onClick={() => handleButtonCancel()}
            >
              Cancelar
            </S.StyledButtonCancel>
            <S.StyledButton
              type="primary"
              htmlType="submit"
              disabled={formDisable}
            >
              Salvar
            </S.StyledButton>
          </S.StyledForm.Item>
        </div>
      </S.StyledForm>
    </Col>
  );
}
